var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"rrss pad-sec"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"title title-36"},[_vm._v(_vm._s(_vm.$t('actualidad.twitter.titulo')))]),_vm._v(" "),_c('div',{staticClass:"flex wrap justify-between"},_vm._l((_vm.tweets),function(e,key){return _c('tweet-el',{key:key,attrs:{"data":e}})}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b8ca4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/actualidad-parts/twitter.vue
// module id = null
// module chunks = 